var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}},[_c('path',{attrs:{"d":"M20.3 2.25C22.1 -0.35 25.9 -0.35 27.7 2.25L46.7 30.15C48.7 33.15 46.6 37.15 43 37.15L5 37.15C1.4 37.15 -0.699997 33.15 1.3 30.15L20.3 2.25Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }